import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule} from '@angular/material/radio';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ReportingDashboardComponent } from './reporting-dashboard.component';
import { IntegrationCardComponent } from './components/integration-card/integration-card.component';
import { RodCardComponent } from './components/rod-card/rod-card.component';
import { EnrichmentCardComponent } from './components/enrichment-card/enrichment-card.component';
import { ExportsCardComponent } from './components/exports-card/exports-card.component';
import { RevDriverCardComponent } from './components/rev-driver-card/rev-driver-card.component';
import { IntentCardComponent } from './components/intent-card/intent-card.component';
import { GrowthSignalsCardComponent } from './components/growth-signals-card/growth-signals-card.component';
import { VisitorIntelCardComponent } from './components/visitor-intel-card/visitor-intel-card.component';
import { IntentSurgeComponent } from './components/intent-surge/intent-surge.component';
import { NewsCardComponent } from './components/news-card/news-card.component';
import { HasChartDataPipe, VisibleCardsCountrPipe, GrowthSignalsAgentLabelPipe, GrowthSignalsViewAllDisabledPipe, TechChangeAgentLabelPipe, TechChangeViewAllDisabledReasonPipe } from './pipes';
import { HasAccessPipeModule, HasPlansPipeModule, IsFeatureFlagEnabledPipeModule, NumberAbbreviatorPipeModule, MinutesToMHDPipeModule, IntentNumberAbbreviatorPipeModule } from '../../pipes';
import { RouterLink } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ChartsModule, DataTableModule, VisitorScriptModule } from '../../components';
import { UserDataByKeyPipeModule } from '../../pipes/user-data-by-key';
import { UserMetaDataByKeyPipeModule } from '../../pipes/user-meta-data-by-key';
import { MatExpansionModule } from '@angular/material/expansion';
import { SavedSearchesCardModule, RecommendedListsCardModule } from './components';
import { MatListModule } from '@angular/material/list';
import { SessionsCardContainerComponent } from './components/sessions-card/sessions-card-container.component';
import { SessionsCardComponent } from './components/sessions-card/components/sessions-card.component';
import { SearchesCardContainerComponent } from './components/searches-card/searches-card-container.component';
import { SearchesCardComponent } from './components/searches-card/components/searches-card.component';
import { IcpCardComponent } from './components/icp-card/components/icp-card.component';
import { IcpCardContainerComponent } from './components/icp-card/icp-card-container.component';
import { GrowthSignalsCardContainerComponent } from './components/growth-signals-card/growth-signals-card-container.component';
import { TechChangeCardContainerComponent } from './components/tech-change-card/tech-change-card-container.component';
import { TechChangeCardComponent } from './components/tech-change-card/tech-change-card.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatRadioModule,
    FontAwesomeModule,
    HasPlansPipeModule,
    RouterLink,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    ChartsModule,
    DataTableModule,
    VisitorScriptModule,
    UserDataByKeyPipeModule,
    HasAccessPipeModule,
    UserMetaDataByKeyPipeModule,
    MatExpansionModule,
    SavedSearchesCardModule,
    RecommendedListsCardModule,
    IsFeatureFlagEnabledPipeModule,
    MatListModule,
    NumberAbbreviatorPipeModule,
    MinutesToMHDPipeModule,
    IntentNumberAbbreviatorPipeModule,
    HasChartDataPipe,
    GrowthSignalsAgentLabelPipe,
    GrowthSignalsViewAllDisabledPipe,
    TechChangeAgentLabelPipe,
    TechChangeViewAllDisabledReasonPipe,
  ],
  declarations: [
    ReportingDashboardComponent,
    IntegrationCardComponent,
    RodCardComponent,
    EnrichmentCardComponent,
    ExportsCardComponent,
    RevDriverCardComponent,
    IntentCardComponent,
    GrowthSignalsCardComponent,
    VisitorIntelCardComponent,
    IntentSurgeComponent,
    NewsCardComponent,
    VisibleCardsCountrPipe,
    SessionsCardContainerComponent,
    SessionsCardComponent,
    SearchesCardContainerComponent,
    SearchesCardComponent,
    IcpCardContainerComponent,
    IcpCardComponent,
    GrowthSignalsCardContainerComponent,
    TechChangeCardContainerComponent,
    TechChangeCardComponent,
  ],
  exports: [ReportingDashboardComponent],
})
export class ReportingDashboardModule {}
